/**
 * Frontend build identity for incident comparison against Worker versions.
 *
 * Vite inlines `VITE_ANVIL_COMMIT` / `VITE_ANVIL_BUILT_AT` at build time.
 * Nothing here is a secret — it is the git SHA and a timestamp.
 */
export function readBuild(env = import.meta.env) {
  const source = env && typeof env === 'object' ? env : {};
  const commit = String(source.VITE_ANVIL_COMMIT || '').trim() || 'dev';
  const builtAt = String(source.VITE_ANVIL_BUILT_AT || '').trim() || null;
  return { commit, builtAt };
}

export function formatBuild(build = readBuild()) {
  const commit = String(build?.commit || 'dev');
  return commit.length > 12 ? commit.slice(0, 12) : commit;
}
